import Sectors from '../components/Home';

function SectorsRoute() {
  return (
    <section>
      <Sectors />
    </section>
  );
}

export default SectorsRoute;
